<template>
  <div class="substep-submit-a-timesheet">
    <div class="substep-header">
      <h3 data-testId="step-title">Submit a Timesheet</h3>
      <p>Your organization may require worked time to be submitted for approval. We filled in some time for you as an example - practice submitting it now!</p>
    </div>
    <div class="substep-body">
      <AppTable
        :table-data="timesheets"
        class="timesheets-table"
      >
        <AppTableColumn
          v-slot="{ row }"
          header="Member"
        >
          <div class="member">
            <AppAvatar
              :avatar="row.avatar"
              size="speck"
            />

            <span
              :title="row.user_name"
              v-text="row.user_name"
            />
          </div>
        </AppTableColumn>
        <AppTableColumn
          v-slot="{ row }"
          header-classes="col-pay-period"
          cell-classes="col-pay-period"
          header="Pay period"
        >
          <span>{{ row.pay_period }}</span>
        </AppTableColumn>
        <AppTableColumn
          v-slot="{ row }"
          header="Time worked"
        >
          <span>{{ row.time_worked }}</span>
        </AppTableColumn>
        <AppTableColumn
          v-slot="{ row }"
          header="Activity"
        >
          <span
            class="activity activity-percent activity-high label label-rounded label-bold"
          >
            {{ row.activity_level }}%
          </span>
        </AppTableColumn>
        <AppTableColumn
          v-slot="{ row }"
          header="Status"
        >
          <span
            class="unusual-activity-confidence-label medium"
          >
            {{ row.status }}
          </span>
        </AppTableColumn>
        <AppTableColumn
          v-slot="{ row }"
          header-classes="col-screenshots"
          cell-classes="col-screenshots"
          header="Screenshots"
        >
          <span>{{ row.screenshots }}</span>
        </AppTableColumn>
        <AppTableColumn
          header-classes="col-actions"
          cell-classes="col-actions"
        >
          <AppButton
            v-if="!isSubmitted"
            class="btn submit-timesheet"
            :loading="isSubmitting"
            :disabled="isSubmitting"
            @click="submitTimesheet"
          >
            {{ isSubmitting ? 'Submitting...' : 'Submit' }}
          </AppButton>
          <AppButton
            v-else
            disabled
            class="btn btn-outline-success disabled"
          >
            Submitted
            <i class="hi hi-check" />
          </AppButton>
        </AppTableColumn>
      </AppTable>
    </div>
  </div>
</template>

<script>
import GettingStartedMixin from '~/mixins/GettingStarted/GettingStartedMixin';
import AppTable from '~/components/AppTable.vue';
import AppTableColumn from '~/components/AppTableColumn.vue';
import AppAvatar from '~/components/AppAvatar.vue';
import AppButton from '~/components/AppButton.vue';

export default {
  name: 'SubmitATimesheet',
  components: {
    AppAvatar,
    AppButton,
    AppTable,
    AppTableColumn,
  },
  mixins: [GettingStartedMixin],
  props: {
    timesheets: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    isSubmitted: false,
    isSubmitting: false,
  }),
  methods: {
    submitTimesheet() {
      this.isSubmitting = true;
      setTimeout(() => {
        this.isSubmitting = false;
        this.isSubmitted = true;
        this.$emit('completeSubstep');
      }, 1000);
    },
  },
};
</script>
